import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Typography, Grid, ButtonGroup, IconButton, CircularProgress, TableSortLabel, TablePagination } from '@material-ui/core';
import Chart from "react-apexcharts";
import Tooltip from '@material-ui/core/Tooltip';
import BarChartIcon from '@material-ui/icons/BarChart';
import ShowChartIcon from '@material-ui/icons/ShowChart';
import MultilineChartIcon from '@material-ui/icons/MultilineChart';
import TableChartIcon from '@material-ui/icons/TableChart';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    container: {
        margin: theme.spacing(2),
        // borderRadius: theme.spacing(2)
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 60,
        maxWidth: 200,
    },
    multiColumnHeader: {
        background: theme.palette.primary.main,
        color: 'white',
        border: '1px solid rgba(224, 224, 224, 1)',
    },
    yearColumn: {
        background: theme.palette.primary.main,
        color: 'white',
        border: '1px solid rgba(224, 224, 224, 1)',
    },
    tableHolder:{
        marginBottom:theme.spacing(2),
    },
    table: {
        marginBottom:theme.spacing(1),
        padding: theme.spacing(2),
        borderCollapse: 'unset',
        maxWidth: '100vw',
        overflow: 'auto'
    },
    link: {
        // background: theme.palette.primary.main,
        color: 'white',
        fontStyle: 'italic',
        padding: theme.spacing(3),
        textDecoration: 'underline',
        justifyContent: 'center',
        textAlign: 'center',
        fontWeight: 'bold',
        marginBottom: theme.spacing(3),
    },
    controlBar: { 
        display: 'flex', 
        justifyContent: 'space-between',
        flexWrap: 'wrap', 
        alignItems: 'center'
    },
    paper: {
        padding: theme.spacing(2),
        //margin:theme.spacing(2),
        textAlign: 'center',
        // borderRadius: theme.spacing(2),
        color: theme.palette.text.secondary,
    },
    switchBase: {
        color: '#ff0000 !important'
    },
    keyVals: {
        //background: theme.palette.primary.main,
        color: 'white',
        padding: theme.spacing(1),
        marginTop: theme.spacing(3),
        textDecoration: 'none',
        textAlign: 'left',
        fontWeight: 800,
    },
    tooltip: {
        //background: theme.palette.primary.main,
        padding: theme.spacing(1),
        fontSize: '14px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        textAlign: 'center',
    },
    tooltipHolder: {
        padding: theme.spacing(3),
        textAlign: 'center',
        height: 'auto',
        '&:hover': {
            color: '#45b6c3',
        }
    },
    buttonGroup: {
        border: 0
    },
    icon:{
        color:'#000 !important',
    },
    active:{
        color:'#000 !important',
    },
}));

export default function TableChart(props) {
    const classes = useStyles();
    const [chartToggle, setChartToggle] = React.useState((props.heading && localStorage.getItem(props.heading.replaceAll(" ","")) && localStorage.getItem(props.heading.replaceAll(" ","")) ==='table') ? true : false);
    const [count, setCount] = React.useState(1);
    const [chartType, setChartType] = React.useState(props.type ? props.type : 'area');
    const [content, setContent] = useState({});
    const [sortKey, setSortKey] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    const [tableContent,setTableContent] = useState([]);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(props.size ? props.size : 5);
    useEffect(() => {
        if (props.content) {
            const data = {
                series: [],
                options: {
                    colors: ['#E81F76', '#102259', '#F5C3CC', '#4395A2', '#FB772E', '#7F2062'],
                    chart: {
                        redrawOnWindowResize: false,
                        height: 150,
                        toolbar: {
                            show: true
                        },
                        zoom: {
                            enabled: true
                        }
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            hideOverflowingLabels: true
                        },
                    },
                    xaxis: {
                        type: 'category',
                        labels: {
                            formatter: function (value, timestamp) {
                                return moment(new Date(value)).format(props.format) // The formatter function overrides format property
                            },
                        },
                        tickPlacement: 'on',
                        categories: [],
                    },
                    legend: {
                        position: 'bottom',
                    },
                    fill: {
                        opacity: 1
                    }
                }
            };

            if(props.yAxisLabel){
                data.options.yaxis={
                    title: {
                      text: props.yAxisLabel,
                      style:{
                          fontFamily:'inherit',
                          fontSize:'inherit',
                          fontWeight:'inherit',
                      }
                    },
                }
            }

            if(props.multiY){
                data.options.yaxis=[
                    {
                        labels: {
                            formatter: function(val, index) {
                                return val.toFixed(0);
                              }
                        },
                        title: {
                          text: props.content.series[0].name,
                          style:{
                              fontFamily:'inherit',
                              fontSize:'inherit',
                              fontWeight:'inherit',
                          }
                        },
                      },
                      {
                        opposite: true,
                        title: {
                            text: props.content.series[1]?.name,
                            style:{
                                fontFamily:'inherit',
                                fontSize:'inherit',
                                fontWeight:'inherit'
                            }
                        }
                      }
                ]
            }

            data.series = props.content.series;
            data.options.xaxis.categories = props.content.categories;
            data.categories = props.content.categories;
            setContent(data)
            var tableData = [];

            props.content.categories.forEach((element,index) => {
                var row = {Date: moment(new Date(element),props.format).valueOf()};
                props.content.series.forEach(item  => {
                   row[item.name] = item.data[index];
                });
                tableData.push(row)
            });
           
            setTableContent(tableData)
        }
    }, [props.content,props.format,props.multiY, props.yAxisLabel,chartType]);

    const handleChartChange = (value) => {
        setChartType(value);
        localStorage.setItem(props.heading.replaceAll(" ",""),value)
        if (value === 'table') {
            setChartToggle(true);
        } else {
            setChartToggle(false);
            setCount(count + 1);
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
      };
    
      const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
      };

    const createSortHandler = (key) => {
        if(sortKey === key){
          setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
        }else{
            setSortOrder('asc');
        }
        setSortKey(key);
    }

    return (
        <div style={{padding: 10, border: '1px solid #CCCDD2', margin: 10}}>
            <div className={classes.controlBar}>
                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                {/* {props.icon} */}
                <div>
                <Typography variant="h6" color="primary" style={{  paddingLeft: 20,
                    paddingRight: 20, fontFamily: 'Sofia-bold', color: '#000'}}>{props.heading}</Typography>
                <Typography variant="subtitle1" color="primary" style={{  paddingLeft: 20,
                    paddingRight: 20, fontFamily: 'Sofia', color: '#000'}}>{props.subTitle}</Typography>
                </div>
                </div>
                
                <div style={{ display: 'flex', verticalAlign: 'center', flexWrap: 'wrap' }}>
                    <ButtonGroup color="primary">
                        <IconButton color={chartType === 'bar' ? 'secondary' : 'default'} size='medium' style={{fontFamily: 'Sofia'}}  className={classes.buttonGroup}  onClick={() => handleChartChange('bar')}>
                            <Tooltip disableFocusListener title="Bar Chart">
                                <BarChartIcon />
                            </Tooltip>
                        </IconButton>
                        <IconButton color={chartType === 'area' ? 'secondary' : 'default'} size='medium'  style={{fontFamily: 'Sofia'}} onClick={() => handleChartChange('area')}>
                            <Tooltip disableFocusListener title="Area Chart">
                                <MultilineChartIcon />
                            </Tooltip>
                        </IconButton>
                        <IconButton color={chartType === 'line' ? 'secondary' : 'default'} size='medium'  style={{fontFamily: 'Sofia'}} onClick={() => handleChartChange('line')}>
                            <Tooltip disableFocusListener title="Line Chart">
                                <ShowChartIcon />
                            </Tooltip>
                        </IconButton>

                        <IconButton color={chartType === 'table' ? 'secondary' : 'default'} size='medium' style={{fontFamily: 'Sofia'}}  onClick={() => handleChartChange('table')}>
                            <Tooltip disableFocusListener title="Table">
                                <TableChartIcon />
                            </Tooltip>
                        </IconButton>
                    </ButtonGroup>

                    {/* <FormControlLabel 
                    control={<PurpleSwitch checked={chartToggle} onChange={handleChartToggle} name="chartSwitch" />}
                    label="Table"/> */}

                    {/* <Tooltip disableFocusListener className={classes.tooltipHolder} title={
                        <div className={classes.tooltip}>
                            Call Counts shows the usage of Operator calls & ivr calls per day in the selected date range
                     </div>
                    } interactive>
                        <InfoIcon />
                    </Tooltip> */}
                </div>
            </div>

            {!content.categories && 
                <CircularProgress />
            }

            {chartToggle && content.categories && content.categories.length > 0 && tableContent &&
                <div>
                <TableContainer component={Paper} className={classes.tableHolder}>
                    <Table  size="small" aria-label="table" className={classes.table}>
                        <TableHead>
                            <TableRow>
                                {Object.keys(tableContent[0]).map((item) =>
                                    (<TableCell key={item} align="center" className={classes.multiColumnHeader} style={{fontFamily: 'Sofia', fontWeight: 'bold', color: '#000'}}> <TableSortLabel
                                    active={sortKey === item}
                                    classes = {{active:classes.active,icon:classes.icon}}
                                    direction={sortOrder === 'asc' ? 'asc' : 'desc'}
                                    onClick={() => createSortHandler (item)}>
                                    {item}
                            </TableSortLabel></TableCell>)
                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                          {tableContent && tableContent.sort((a,b) => 
                    sortOrder === 'asc' ? a[sortKey] - b[sortKey] : b[sortKey] - a[sortKey])
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(item => (
                                <TableRow hover key={item.Date}>

                                    {Object.keys(item).map(itemKey =>
                                        (
                                             <TableCell component="th" scope="row" align="center" style={{fontFamily: 'Sofia'}}>
                                                {itemKey === 'Date' ? (() => {
                                                    const date = new Date(item[itemKey]);
                                                    return moment(date).format("ddd MMM DD")
                                                })() : item[itemKey]}
                                            </TableCell>
                                        )
                                    )}

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                rowsPerPageOptions={[5, 10, 25,31]}
                component="div"
                count={tableContent.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </div>
            }

            <Grid container spacing={2}>
                {!chartToggle && content && content.series && content.categories.length > 0 &&
                    <Grid item lg={12} xs={12}>
                        <Chart
                            key={'myApexChart' + count}
                            series={content.series}
                            options={content.options}
                            height={300}
                            type={chartType}
                        />
                    </Grid>
                }



            </Grid>

            {content && content.series && content.categories.length === 0 &&
                <Typography style={{  paddingLeft: 20, paddingRight: 20, fontFamily:'Sofia'}} variant="overline" >No Records Found</Typography>
            }
        </div>);
}